(function Module() {
	'use strict';

	var _ = require('lodash');

	var basePatterns = {
		date: '^\\d{4}-\\d{2}-\\d{2}$',
		digits: '^\\d*$',
		email: '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$',
		integer: '^-?([0-9]+)$',
		money: '[\\d,]*\\.?[\\d]*',
		number: '^-?([0-9]+\\.?[0-9]*|[0-9]*\\.?[0-9]+)$',
		phone: '\\([2-9]\\d{2}\\)[2-9]\\d{2}-\\d{4}',
		ausPhone: '\\(\\d{2}\\) \\d{4} \\d{4}',
		postCode: '^[A-Z0-9]{5}(?:-\\d{4})?$',
		string: '^\\S+[\\S\\s]*$',
		//  SSNs currently allow all permutations with 7 and 8 in first position (http://www.ssa.gov/kc/SSAFactSheet--IssuingSSNs.pdf)
		ssn: '^((?!000)(?!666)(?:[0-8]\\d{2}))-((?!00)\\d{2})-((?!0000)\\d{4})$',
		url: '^(https?:\\/\\/)?([\\da-z\\.-]+)\\.([a-z\\.]{2,6})([\\/\\w \\.-]*)*\\/?$',
		uuid: '^[A-Za-z0-9]{8}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{12}$',
		taxId: '^\\d{2}-\\d{7}$'
	};

	var extendedBasePatterns = _.merge({}, basePatterns, {
		phoneWithExtension: basePatterns.phone + '.*'
	});

	module.exports = _.merge({}, extendedBasePatterns, {
		alphaNumericExtended: "^[A-Za-z0-9\\ \\']+$",
		time: '^\\d{2}:\\d{2}:\\d{2}$',
		dateForDisplay: '^\\d{2}\\/\\d{2}\\/\\d{4}$',
		dateOrEmpty: '(' + extendedBasePatterns.date + ')|^$',
		dateWithTime: '(^\\d{4}-\\d{2}-\\d{2} \\d{2}:\\d{2}:\\d{2}$)',
		dateWithTimeOrEmpty: '(^\\d{4}-\\d{2}-\\d{2} \\d{2}:\\d{2}:\\d{2}$)|^$',
		digits: '^\\d*$',
		digitsOrEmpty: '(' + extendedBasePatterns.digits + ')|^$',
		emailOrEmpty: '(' + extendedBasePatterns.email + ')|^$',
		float: '^\\d+\\.?\\d*$|\\d*\\.?\\d+$',
		integerOrEmpty: '(' + extendedBasePatterns.integer + ')|^$',
		invitationKey: '^[A-Za-z]{5}$',
		middleInitial: '[A-Z]?',
		moneyPositiveOrNegative: '^-?' + extendedBasePatterns.money,
		moneyOrEmpty: '(' + extendedBasePatterns.money + ')|^$',
		monthYear: '^\\d{2}/?\\d{4}$',
		numberOrEmpty: '(' + extendedBasePatterns.number + ')|^$',
		password: '^\\S\\S*$',
		passwordOrEmpty: '^\\S\\S*$|^$',
		percent: '^(\\d+\\.?)+\\d{0,2}%$',
		phoneOrEmpty: '(' + extendedBasePatterns.phone + ')|^$',
		ausPhoneOrEmpty: '(' + extendedBasePatterns.ausPhone + ')|^$',
		phoneWithExtensionOrEmpty: '(' + extendedBasePatterns.phoneWithExtension + ')|^$',
		ssnOrEmpty: '(' + extendedBasePatterns.ssn + ')|^$',
		// WARNING: testing against undefined will return true.
		stringOrEmpty: '(' + extendedBasePatterns.string + ')|^$',
		urlOrEmpty: '(' + extendedBasePatterns.url + ')|^$',
		uuidOrEmpty: '(' + extendedBasePatterns.uuid + ')|^$',
		taxIdOrEmpty: '(' + extendedBasePatterns.taxId + ')|^$',
		postCode: extendedBasePatterns.postCode,
		postCodeOrEmpty: '(' + extendedBasePatterns.postCode + ')|^$'
	});
})();
